import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** Usage: place inside a CDK draggable and forward keydown for keyboard reordering. */
@Component({
  selector: 'app-drag-handle',
  templateUrl: './app-drag-handle.component.html',
  styleUrls: ['./app-drag-handle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppDragHandleComponent {
  @Input() label = 'Reorder item';
  @Input() disabled = false;
  @Input() compact = false;
  @Output() keydown = new EventEmitter<KeyboardEvent>();
}
